module.exports = {
    ADOBE_CLIENT_ID_MAP: {
        localhost:  '4f2b6e30241345c3ac01ce68051169d9', // localhost           // yarn develop
        mizer:      '67d907ee47fa44379278255918d5b814', // mizer Argentina       // yarn mizer-build
        stage:      'd264a6e45a6042758decb13c52ce6938', // S3 stage            // yarn build
        production: 'acb90ac470ec4c6bac0e36469e41a859'  // keytrudahcp.com     // yarn production-build
    },
    ADOBE_VIEWER_SDK_URL: 'https://documentcloud.adobe.com/view-sdk/viewer.js',
    VIEWER_CONFIG: {
        /* If true, tools such as sticky note, highlight, and so on appear in the upper toolbar. */
        showAnnotationTools: true,

        /* If true, form filling is enabled and users can edit fields. */
        enableFormFilling: true,

        /* If true, the left-hand pane in file preview displays. The pane allows user to toggle thumbnails on and off. */
        showLeftHandPanel: true,

        /* If true, a download button appears in the overflow menu on the top bar. */
        showDownloadPDF: true,

        /* If true, then a print PDF option appears in the overflow menu on the top bar. */
        showPrintPDF: true,

        /* If true, the page control toolbar displays. */
        showPageControls: true,

        /* 	If true, the page control toolbar is locked to the bottom bar and expands to the page width.
        End users can still dock/undock via the dock button on the page control toolbar. */
        dockPageControls: true,

        /* Allowed possible values are "FIT_PAGE", "FIT_WIDTH" or "".
        FIT_WIDTH expands the page horizontally to the full width of the document pane; with this setting,
        the full page is unlikely to display on a single screen. Scrolling may be required.
        FIT_PAGE displays the entire page in the current view pane so that no scrolling is required.
        Note that end users can toggle the mode via the Fit Width button on the page controls bar (if present). */
        defaultViewMode: "SIZED_CONTAINER",
    }
}